var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66048 17.9606C4.71882 17.9606 0.702148 13.9439 0.702148 9.00228C0.702148 4.06061 4.71882 0.0439453 9.66048 0.0439453C14.6021 0.0439453 18.6188 4.06061 18.6188 9.00228C18.6188 13.9439 14.6021 17.9606 9.66048 17.9606ZM9.66048 1.29395C5.41048 1.29395 1.95215 4.75228 1.95215 9.00228C1.95215 13.2523 5.41048 16.7106 9.66048 16.7106C13.9105 16.7106 17.3688 13.2523 17.3688 9.00228C17.3688 4.75228 13.9105 1.29395 9.66048 1.29395Z",
    fill: "#8F8F8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.754 12.2783C12.6456 12.2783 12.5373 12.2533 12.4373 12.1866L9.85397 10.645C9.2123 10.2616 8.7373 9.41996 8.7373 8.67829V5.2616C8.7373 4.91993 9.02064 4.6366 9.3623 4.6366C9.70397 4.6366 9.9873 4.91993 9.9873 5.2616V8.67829C9.9873 8.97829 10.2373 9.41995 10.4956 9.56995L13.079 11.1116C13.379 11.2866 13.4706 11.67 13.2956 11.97C13.1706 12.17 12.9623 12.2783 12.754 12.2783Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clockIcon.b01c9edfdeabf1b1108e530db185d4ac.svg";
export { ForwardRef as ReactComponent };